const getCollectionReferences = (schema, references=[]) => {
  schema.forEach((field) => {
    if(field.type == "SELECT" && field.collection_options)
      references.push(field.collection_options.map((opt) => opt.query));
    if(field.type == "SECTION" && field.fields)
      getCollectionReferences(field.fields, references);
  });
  return references.flat();
}

const parseSchemaOptions = (collections, schema) => {
  return schema.map((field) => {
    if(field.type == "SELECT")
      return parseFieldOptions(collections, field);
    if(field.type == "SECTION")
      return { ...field, fields: parseSchemaOptions(collections, field.fields) };
    return field;
  });
}

const parseFieldOptions = (collections, field) => {

  const options = [];
  
  for(const fieldQuery of field?.collection_options ?? []) {

    const collectionOption = collections?.find((c) => c.query == fieldQuery?.query);
    if(collectionOption)
      collectionOption.data?.map((value) => {
        if(value.pk_label)
          options.push({ value: value.pk_label, label: value.pk_label });
      });

  }

  return { ...field, options: (field.options??[]).concat(options) };

}

export {
  parseSchemaOptions,
  getCollectionReferences
}